import React from 'react';

const NewsSummaryFormModal = React.lazy(() => import('../components/FormModal'));
const newsSummaryModalRegistry = {
    company_newsSummaryId: NewsSummaryFormModal
};
export default newsSummaryModalRegistry;
